module.exports = __webpack_public_path__ + "static/img/3.8053375.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/17/zh/3.png
// module id = QVQF
// module chunks = 0